import { serviceTypeConstants } from '../_constants/serviceType.constants';

export function success(data, taskId) { return { type: serviceTypeConstants.SERVICETYPE_SUCCESS, data, taskId } }
export function failure(error) { return { type: serviceTypeConstants.SERVICETYPE_FAILURE, error } }